module.exports = __webpack_public_path__ + "img/67_03.62e0d8ce.png";